@if (!dialogName) {
  <div class="standard-dialog confirm-dialog">
    <div class="header" mat-dialog-title>
      <div class="title-section">
        <h2>{{ data.title }}</h2>
      </div>
      <button mat-icon-button (click)="dialogRef.close(0)" class="close-btn">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <mat-dialog-content class="confirm-body">
      <p class="confirm-message">{{ data.message }}</p>
    </mat-dialog-content>

    <mat-dialog-actions class="footer">
      <div class="right-actions">
        <button mat-button (click)="dialogRef.close(0)">
          {{ 'Confirm.Cancel' | translate }}
        </button>
        @if (data.alternateYes) {
          <button mat-flat-button color="primary" (click)="dialogRef.close(-1)">
            {{ data.alternateYes }}
          </button>
        }
        <button mat-flat-button color="primary" (click)="dialogRef.close(1)">
          {{ data.yesText || ('Confirm.Yes' | translate) }}
        </button>
      </div>
    </mat-dialog-actions>
  </div>
}

@if (dialogName === 'sessionExpulsion') {
  <div class="standard-dialog confirm-dialog">
    <div class="header" mat-dialog-title>
      <div class="title-section">
        <h2>{{ 'Confirm.SessionExpulsionTitle' | translate }}</h2>
      </div>
    </div>

    <mat-dialog-content class="confirm-body">
      <p class="confirm-message">{{ 'Confirm.SessionExpulsionMessage' | translate }} {{ deconnectionTimer }}</p>
    </mat-dialog-content>

    <mat-dialog-actions class="footer">
      <div class="right-actions">
        <button mat-flat-button color="primary" (click)="dialogRef.close(true)">
          {{ 'Confirm.SessionExpulsionConfirm' | translate }}
        </button>
      </div>
    </mat-dialog-actions>
  </div>
}
